'use strict'

var create = require('./util/create')
var caseInsensitiveTransform = require('./util/case-insensitive-transform')

module.exports = create({
  space: 'xmlns',
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  transform: caseInsensitiveTransform,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/xmlns.js
// module id = 111
// module chunks = 33019919093843 87034247430840 144482056661899